/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type CreateExperimentPathParams = NonNullable<operations['createExperiment']['parameters']['path']>;

export type CreateExperimentRequestBody = OperationRequestBodyContent<operations['createExperiment']>;

export interface Input extends CreateExperimentPathParams {
  apiVersion?: string;
  body: CreateExperimentRequestBody;
}

export async function createExperiment(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/environments/{environmentKey}/experiments', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
